<template>
	<div
		v-if="data"
		class="chart-container"
		:class="[{ inline: inline }, legend]"
	>
		<div class="chart-wrapper">
			<canvas
				ref="pieChart"
				width="128"
				height="128"
				role="img"
				:aria-label="data.ariaLabel"
			></canvas>
			<div
				v-if="data.title || data.fullAmount"
				class="chart-title-wrapper"
				aria-hidden="true"
			>
				<div :class="['heading-5', 'chart-title', { small: data.smallText }]">
					{{ data.title }}
				</div>
				<div class="heading-4 chart-full-amount">
					{{ data.fullAmount | currency }}
				</div>
			</div>
		</div>
		<div class="chart-legend">
			<div
				v-for="(item, index) in data.dataset"
				:key="index"
				class="chart-legend-item"
				:class="{ 'label-only': item.labelOnly }"
			>
				<div
					v-if="item.title"
					aria-hidden="true"
					class="chart-legend-color"
					:style="{ backgroundColor: bgColors[index] }"
				></div>

				<div v-if="legend == 'row'" class="heading-5">
					<span class="title">{{ item.title }}:</span>
					{{ item.value | currency }}
					<div v-if="item.legendAdditionalInfo" class="additional-info">
						{{ item.legendAdditionalInfo }}
					</div>
				</div>

				<div v-else-if="item.title" class="body-text-2">
					<span class="title">{{ item.title }}:</span>
					{{ item.value | currency }}
					<div v-if="item.legendAdditionalInfo" class="additional-info">
						{{ item.legendAdditionalInfo }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Chart from 'chart.js';
export default {
	props: {
		data: {
			type: Object,
			default: null
		},
		inline: {
			type: Boolean,
			default: false
		},
		legend: {
			type: String,
			default: 'column'
		},
		useEmptyData: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			bgColors: [
				'rgba(164, 124, 159, 1)',
				'rgba(4, 161, 140, 1)',
				'rgba(218, 113, 14, 1)',
				'rgba(70, 146, 196, 1)',
				'rgba(99, 108, 129, 1)'
			],
			emptyDataColors: ['rgba(164, 124, 159, 1)', 'rgba(196, 196, 196, 1)'],
			chart: null
		};
	},
	watch: {
		data(dataValue) {
			if (dataValue) {
				this.drawChart();
			}
		}
	},
	mounted() {
		if (this.data) {
			this.drawChart();
		}
	},
	beforeDestroy() {
		if (this.chart) {
			this.chart.destroy();
		}
	},
	methods: {
		drawChart() {
			if (this.chart) {
				this.chart.destroy();
			}

			var ctx = this.$refs.pieChart.getContext('2d');
			this.chart = new Chart(ctx, {
				type: 'doughnut',
				data: {
					labels: [this.$t('amountSpent'), this.$t('amountLeftToSpend')],
					datasets: [
						{
							data: this.data.dataset
								.filter(item => !item.labelOnly)
								.map(item => {
									return item.value | 1;
								}),
							backgroundColor: this.useEmptyData
								? this.emptyDataColors
								: this.bgColors,
							borderWidth: 0
						}
					]
				},
				options: {
					legend: {
						display: false
					},
					tooltips: {
						enabled: false
					},
					cutoutPercentage: 85
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.chart-container {
	display: flex;
	flex-direction: column;

	&.row {
		flex-direction: row;
		align-items: center;

		.chart-legend {
			margin-left: 16px;
		}
	}

	.heading-5 {
		color: $font-gray;

		&.small {
			@media (min-width: $breakpoint-mid) {
				font-size: 12px;
				letter-spacing: 1px;
			}
		}
	}

	&.inline {
		flex-direction: row;
		align-items: center;

		.chart-wrapper {
			flex-shrink: 0;
		}

		.chart-legend {
			margin-top: 0;
			margin-left: 16px;
			flex-grow: 1;
		}
	}

	.chart-wrapper {
		position: relative;
		width: 130px;
		height: 128px;

		.chart-title-wrapper {
			display: flex;
			flex-direction: column;
			justify-content: center;
			height: 112px;
			width: 112px;
			border-radius: 100%;
			text-align: center;
			position: absolute;
			top: 8px;
			left: 8px;

			.heading-4 {
				margin: 0;
			}
		}
	}
	.chart-legend {
		display: flex;
		flex-direction: column;
		margin-top: 16px;

		.chart-legend-item {
			display: flex;
			align-items: baseline;
			margin-bottom: 8px;

			&.label-only {
				border-top: 1px solid $border-color;
				padding-top: 8px;

				.chart-legend-color {
					background-color: transparent !important;
				}
			}

			.body-text-2 {
				color: $font-header;
			}

			.chart-legend-color {
				height: 10px;
				width: 10px;
				border-radius: 100%;
				margin-right: 16px;
				flex-shrink: 0;
			}

			.additional-info {
				font-family: 'RobotoRegular';
				font-size: 12px;
				color: $font-header;
				margin-top: 4px;

				@media (min-width: $breakpoint-mid) {
					font-size: 14px;
				}
			}
		}
	}
}
</style>
